import { useEffect, useReducer } from 'react';
import { AppContext, appReducer, initialState } from './appReducer';
import Landing from '../Landing/Landing';
import WorkflowEngine from '../WorkflowEngine/WorkflowEngine';
import NewWorkflow from '../NewWorkflow/NewWorkflow';
import { WorkflowEngineMode } from '../WorkflowEngine/workflowEngineReducer';
import { AppActionKind, AppPageKind } from './types';
import DuplicateWorkflow from '../DuplicateWorkflow/DuplicateWorkflow';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { MathJaxContext } from 'better-react-mathjax';
import config from '../Shared/config';

export default ({ role }: { role: string }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  const { workflowId, workflowName, workflowType, page } = state;

  const setAppContext = async () => {
    dispatch({
      type: AppActionKind.SET_APPCONTEXT,
      payload: role as string
    });
  };

  useEffect(() => {
    setAppContext();
  }, []);

  const renderPageContent = () => {
    switch (page) {
      case AppPageKind.LANDING:
        return <Landing />;
      case AppPageKind.FORM_BUILDER:
        return (
          <WorkflowEngine
            role={role}
            externalId={workflowId}
            mode={WorkflowEngineMode.BUILD}
          />
        );
      case AppPageKind.NEW_WORKFLOW:
        return <NewWorkflow />;
      case AppPageKind.DUPLICATE_WORKFLOW:
        return (
          <DuplicateWorkflow
            workflowId={workflowId}
            workflowName={workflowName}
            workflowType={workflowType}
          />
        );
    }
  };
  // eslint-disable-next-line no-console
  console.log(`V${process.env.REACT_APP_VERSION}`);
  return (
    <DndProvider backend={HTML5Backend}>
      <MathJaxContext
        version={3}
        config={{
          loader: { load: ['input/asciimath'] }
        }}
        src="https://cdnjs.cloudflare.com/ajax/libs/mathjax/3.2.2/es5/tex-chtml.min.js"
      >
        <AppContext.Provider value={{ state, dispatch }}>
          {renderPageContent()}
        </AppContext.Provider>
      </MathJaxContext>
    </DndProvider>
  );
};
